
<div class="p-3 d-flex flex-column gap-3">

  <div class="form-check form-switch">
    <input class="form-check-input" type="checkbox" role="switch" id="switchThemeDark" [(ngModel)]="darkmode" (change)="changeSetting()">
    <label class="form-check-label" for="switchThemeDark">Dark theme</label>
  </div>

  <div class="form-check form-switch">
    <input class="form-check-input" type="checkbox" role="switch" id="switchClock24" [(ngModel)]="clock24" (change)="changeSetting()">
    <label class="form-check-label" for="switchClock24">24-hour clock</label>
  </div>

  <div class="row d-flex flex-column">
    <div class="col">
      <label>Text size zoom</label>
    </div>
    <div class="col">
      <div class="form-inline d-flex flex-row justify-content-start gap-2">
        <div class="btn btn-sm {{ textSize === 'smaller' ? 'btn-main' : 'btn-secondary' }}" (click)="textSize = 'smaller'; changeSetting()">
          <span>75%</span>
        </div>
        <div class="btn btn-sm {{ textSize === 'small' ? 'btn-main' : 'btn-secondary' }}" (click)="textSize = 'small'; changeSetting()">
          <span>80%</span>
        </div>
        <div class="btn btn-sm {{ textSize === 'medium' ? 'btn-main' : 'btn-secondary' }}" (click)="textSize = 'medium'; changeSetting()">
          <span>90%</span>
        </div>
        <div class="btn btn-sm {{ textSize === 'normal' ? 'btn-main' : 'btn-secondary' }}" (click)="textSize = 'normal'; changeSetting()">
          <span>100%</span>
        </div>
        <div class="btn btn-sm {{ textSize === 'large' ? 'btn-main' : 'btn-secondary' }}" (click)="textSize = 'large'; changeSetting()">
          <span>125%</span>
        </div>
      </div>
    </div>
  </div>
</div>
